import { h, Component } from "preact";

import style from "./style";

class ListFilter extends Component {
  state = {
    inputValue: ""
  };

  handleInput = event => {
    let newValue = event.target.value.length > 0 ? event.target.value : false;
    this.setState(previousState => ({
      ...previousState,
      inputValue: newValue || ''
    }));
    this.props.handleFilterChange(newValue);
  };

  clearFilter = () => {
    this.setState(previousState => ({
      ...previousState,
      inputValue: ''
    }));
    this.props.handleFilterChange(false);
  }

  componentWillReceiveProps(nextProps) {
    // Gets set to true when the searchType changes, so reset filter input
    if (nextProps.shouldResetFilter) {
      this.setState(previousState => ({
        ...previousState,
        inputValue: ''
      }));
    }
  }

  render() {
    return (
      <div class={style["list-filter"]}>
        <input
          type="text"
          onInput={this.handleInput}
          placeholder="Filter..."
          class={style["list-filter__input"]}
          value={this.state.inputValue}
        />
        <span class={style['list-filter__clear']} onClick={this.clearFilter}>X</span>
      </div>
    );
  }
}

export default ListFilter;
